export default {
  API_BASE_URL: "https://spotsapi.hairscoutwebapp.com/api",
  INVITE_BASE_URL: "https://app.sxene.co?eventId=",
  SPOTS_BASE_URL: "https://app.sxene.co/",
};
